<template>
    <component :is="component" :memberData="memberData" v-if="component"></component>
</template>

<script>
export default {
    name: "MemberDetailLink",
    mixins: [],
    components: {
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {
        detailLayout: '',
        memberData: {default: () => {}},
    },
    data() {
        return{
            component: null,
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
        this.loader()
            .then(() => {
                this.component = () => this.loader()
            })
            .catch(() => {
                this.component = () => import('@/template/member/detail/MemberDetailDefaultLayout')
            })
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
        loader() {
            if (!this.detailLayout) {
                return null
            }
            return () => import(`@/template/member/detail/${this.detailLayout}`)
        },
    },
    methods:{

    },
    watch: {

    },
}
</script>

<style scoped>

</style>
